import {EventEmitter} from 'events';

import SiteHardPasswordApi from 'Services/Api/Base/SiteHardPassword';

class SiteHardPassword extends EventEmitter {
    /**
     * @var authed
     * @type {boolean}
     */
    authed = window.base.using_site_hard_password ? null : true;

    /**
     * @method authed
     * @return {boolean}
     */
    get authed () {
        return this.authed;
    };

    /**
     * @method refresh
     * @return {Promise<void>}
     */
    refresh = async () => {
        if (window.base.using_site_hard_password) {
            const request = await SiteHardPasswordApi.check();

            this.authed = request.success ? request.data.authed : false;
        }
    };
}

export default new SiteHardPassword;